import React from "react";
import {
  Stack,
  Text,
  PrimaryButton,
  Link,
  IStackStyles,
  IStackTokens,
} from "@fluentui/react";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import QDBLogo from "../../assets/qdb_logo.svg";
import SanadBot from "../../assets/sanad-bot.gif";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../assets/bg-big.png";

const mainContainer = mergeStyles({
  minHeight: "100vh",
  background: "#0A1A2F",
  color: "white",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    opacity: 0.4,
    zIndex: 0,
  },
});

const headerStyles: IStackStyles = {
  root: {
    padding: "16px",
  },
};

const mainContentStyles: IStackStyles = {
  root: {
    height: "calc(100vh - 64px)", // Accounting for header height
    position: "relative",
  },
};

const chatBubbleStyles = mergeStyles({
  position: "relative",
  maxWidth: "520px",
  background: "#3a445d",
  backdropFilter: "blur(20px)",
  padding: "24px 32px",
  borderRadius: "24px",
  marginBottom: "32px",
  border: "1px solid #7FCAC1",
});

const chatTextStyles = mergeStyles({
  fontSize: "18px",
  lineHeight: "28px",
  color: "white",
  "& span": {
    color: "#22D3EE",
    fontWeight: 600,
  },
});

const robotImageContainer = mergeStyles({
  width: "192px",
  height: "192px",
  marginBottom: "32px",
});

const stackTokens: IStackTokens = {
  childrenGap: 20,
};

const Landing: React.FC = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/chathome"); // Navigate to the Chat route
  };

  return (
    <div className={mainContainer}>
      {/* Header */}
      <Stack horizontal horizontalAlign="space-between" styles={headerStyles}>
        <img src={QDBLogo} alt="QDB Logo" style={{ height: "32px" }} />
        <Link href="https://www.qdb.qa" styles={{ root: { color: "white" } }}>
          www.qdb.qa
        </Link>
      </Stack>

      {/* Main Content */}
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        styles={mainContentStyles}
        tokens={stackTokens}
      >
        {/* Chat Bubble */}
        {/* Chat Bubble */}
        <div className={chatBubbleStyles}>
          <div className={chatTextStyles}>
            👋 Hello my name is Sanad! Ready to start a chat or ask me anything?
            Click <span>"Get Started"</span> below, and let's dive into your
            questions and conversations!
          </div>
        </div>

        {/* Robot Image */}
        <div className={robotImageContainer}>
          <img
            src={SanadBot}
            alt="Sanad Robot"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>

        {/* Get Started Button */}
        <PrimaryButton
          onClick={handleGetStarted}
          text="Get started"
          styles={{
            root: {
              backgroundColor: "#22D3EE",
              borderRadius: "9999px",
              padding: "12px 32px",
            },
            rootHovered: {
              backgroundColor: "#06B6D4",
            },
          }}
        />

        {/* Background Pattern */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: -1,
          }}
        >
          {/* You can add your background image or pattern here */}
        </div>
      </Stack>
    </div>
  );
};

export default Landing;
